<template>
  <div>
    <p class="header">
      Take a look at this hotel room, in Paris, for a weekend in June.
    </p>
    <div class="image-holder">
      <img class="image" src="@/assets/main.png" />
      <div class="small-image-holder">
        <img class="image" src="@/assets/side1.png" />
        <img class="image" src="@/assets/side2.png" />
      </div>
    </div>
    <p class="header underline">
      How much do you think this room costs for a weekend in June?
    </p>
    <bg-input :autofocus="true" class="input" name="price" v-model="guess" />
    <bg-button
      :isLoading="isLoading"
      class="button"
      @click="postData()"
      text="Next"
      :disabled="!$v.guess.required || !$v.guess.integer"
    ></bg-button>
  </div>
</template>

<style scoped>
.underline {
  text-decoration: underline;
}
.button {
  margin: 20px;
}
.input {
  width: 140px;
  margin: auto;
}
.header {
  margin-bottom: 40px;
  font-size: 18px;
}
.paragraph {
  margin-bottom: 10px;
}
.image-holder {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  min-height: 341px;
}
.image {
  width: auto;
  margin: 5px;
  max-width: initial;
}
.small-image-holder {
  display: flex;
  flex-direction: column;
}
</style>

<script>
import BgButton from "../components/bg-button";
import BgInput from "../components/bg-input";
import required from "vuelidate/lib/validators/required";
import integer from "vuelidate/lib/validators/integer";
export default {
  name: "App",
  components: {
    BgInput,
    BgButton
  },
  data() {
    return {
      isLoading: false,
      guess: ""
    };
  },
  validations: {
    guess: {
      required,
      integer
    }
  },
  computed: {
    price() {
      return this.$store.state.price;
    }
  },
  methods: {
    postData() {
      this.isLoading = true;
      const group = this.price === 5000 ? "groupB" : "groupA";
      this.$store.commit("setGuess", this.guess);
      fetch("/.netlify/functions/updateRow", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ experiment: group, value: this.guess })
      })
        .then(response => response.json())
        .then(data => {
          this.isLoading = false;
          this.error = data;
          this.$router.push({ name: "stepsix" });
        })
        .catch(error => {
          this.isLoading = false;
          this.$router.push({ name: "stepsix" });
          this.error = error;
        });
    }
  }
};
</script>
